import api from './index';
import { WorkLog, WorkLogStatus } from '../../types';

// 獲取工作日誌列表
export const getWorkLogs = async (projectId?: string, status?: WorkLogStatus) => {
  const params = new URLSearchParams();
  if (projectId) params.append('projectId', projectId);
  if (status) params.append('status', status);
  
  const response = await api.get(`/worklogs?${params.toString()}`);
  return response.data;
};

// 獲取單個工作日誌
export const getWorkLog = async (id: string) => {
  const response = await api.get(`/worklogs/${id}`);
  return response.data;
};

// 創建工作日誌
export const createWorkLog = async (data: Partial<WorkLog>) => {
  const response = await api.post(`/worklogs`, data);
  return response.data;
};

// 更新工作日誌
export const updateWorkLog = async (id: string, data: Partial<WorkLog>) => {
  const response = await api.put(`/worklogs/${id}`, data);
  return response.data;
};

// 刪除工作日誌
export const deleteWorkLog = async (id: string) => {
  const response = await api.delete(`/worklogs/${id}`);
  return response.data;
};

// 添加議題到工作日誌
export const addIssuesToWorkLog = async (id: string, issueIds: string[]) => {
  const response = await api.post(`/worklogs/${id}/issues`, { issueIds });
  return response.data;
};

// 從工作日誌移除議題
export const removeIssueFromWorkLog = async (workLogId: string, issueId: string) => {
  const response = await api.delete(`/worklogs/${workLogId}/issues/${issueId}`);
  return response.data;
};

// 更新議題排序
export const updateIssueOrder = async (
  workLogId: string, 
  issueOrders: { issueId: string; sortOrder: number }[]
) => {
  const response = await api.put(`/worklogs/${workLogId}/issues/order`, { issueOrders });
  return response.data;
};

// 匯出工作日誌
export const exportWorkLog = async (id: string, format: 'pdf' | 'docx' = 'pdf') => {
  const response = await api.post(
    `/worklogs/${id}/export`, 
    { format },
    { responseType: 'blob' }
  );
  
  // 創建下載連結
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `worklog-${id}.${format}`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
  
  return response.data;
};